import React, { useContext, useEffect, useRef, useState } from "react";
import LYWOLogoSmall from "../assets/images/LYWOLogoSmall.svg";
import ArrowCircleLeftLogo from "../assets/images/arrow-circle-left.svg";
import logOut from "../assets/images/log-out.svg";
import arrowRight from "../assets/images/arrow-right-pagination.svg";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";
import GroupList from "../pages/grouplist";
import { Form, Modal } from "react-bootstrap";
import JobList from "../pages/JobList";
import job from "../../src/assets/images/jobs.png";
import job1 from "../../src/assets/images/jobss.png";
import sh from "../../src/assets/images/sh.png";
import AccessCode from "../pages/AccessCode";
import sh1 from "../../src/assets/images/sho.png";

const NewHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const timeoutRef = useRef(null);

  const { setIsLogin, setAdminData, adminInitialData, openSideBar, setOpenSideBar, activeMenu, setActiveMenu, adminData } = useContext(AppContext);

  const [showCodeRespondent, setShowCodeRespondent] = useState("");
  const [companyDtls, setCompnayDtls] = useState({
    company: "",
    designation: "",
    position: "",
  });


  const [show, setShow] = useState(false);

  const handleClose = (e) => {
    e.preventDefault();
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleLogout = () => {
    localStorage.clear();
    setIsLogin(false);
    setAdminData(adminInitialData);
    navigate("/Login");
  };

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      handleLogout();
    }, 1 * 60 * 60 * 1000);
  };

  useEffect(() => {
    const activityEvents = [
      "mousedown",
      "mousemove",
      "keydown",
      "scroll",
      "touchstart",
    ];

    const handleActivity = () => {
      resetTimeout();
    };

    activityEvents.forEach((event) => {
      document.addEventListener(event, handleActivity);
    });

    resetTimeout();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      activityEvents.forEach((event) => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, []);

  const navigate = useNavigate();

  const toggleSidebar = () => {
    setOpenSideBar(!openSideBar);
  };

  const handleMenuClick = (menu) => {

    setActiveMenu(menu);
    setOpenSideBar(true); // Open sidebar when menu item is clicked
  };

  const handleNavButtonClick = (menu) => {
    sessionStorage.setItem('activeMenu', menu)


    navigate("/")

    setActiveMenu(menu);
    setOpenSideBar(true); // Open sidebar when nav button is clicked
  };
  return (
    <div
      className={`canLisContentWrap ${!openSideBar ? "fullwidth" : null}`}
    >
      <div className="canLisNavBar  ">
        <div className="OrgArea ">
          {!openSideBar && (
            <div>
              <img
                src={arrowRight}
                onClick={toggleSidebar}
                style={{ cursor: "pointer" }}
              />
            </div>
          )}
          <a href="/">
            <img
              src={LYWOLogoSmall}
              className="canLisLogoStyle"
              alt="Logo"
            />
          </a>
          {console.log("activeMenu-->", activeMenu)}

          <div className="tab-buttons-container">


            <button
              style={{
                borderRadius: "0px",
                display: "flex",
                flexDirection: "column",
              }}
              onClick={() => handleNavButtonClick("grouplist")}
              className={`tab-button ${activeMenu === "grouplist" ? "active" : ""
                }`}
            >
              {/* <img
                src={activeMenu === "grouplist" ? sh : sh1}
                width={17}
                height={17}
              /> */}
              Posted Jobs
            </button>
            {/* {
              adminData?.isHaveJd && */}

            <button
              style={{
                borderRadius: "0px",
                display: "flex",
                flexDirection: "column",
              }}
              onClick={() => handleNavButtonClick("JobList")}
              className={`tab-button ${activeMenu === "JobList" ? "active" : ""
                }`}
            >
              {/* <img
                src={activeMenu === "grouplist" ? job1 : job}
                width={17}
                height={17}
              /> */}
              Job Drafts
            </button>
            {/* } */}
          </div>
          <div className="ms-5 mt-auto">
            <nav>
              {/* <ol className="breadcrumb" style={{ marginBottom: "7px" }}>+
                    <li className="breadcrumb-item" style={{ cursor: "pointer" }} onClick={() => handleMenuClick("grouplist")}>
                      All Jobs
                    </li>
                    <li className="breadcrumb-item bread-active">
                      {showCodeRespondent}
                    </li>
                  </ol> */}
            </nav>
          </div>

          <div className="d-flex align-items-center"></div>
        </div>
        <div className="profileArea">
          <h5>{`${companyDtls?.designation ? companyDtls?.designation : "Admin"
            }`}</h5>
          <div>
            <img
              src={logOut}
              className="profileOptnIcon"
              alt="logo"
              onClick={handleLogout} 
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewHeader